import React from "react";
import { BannerTable } from "../../../Common/BannerTable";
import { DeleteModal } from "../../../Common/DeleteModal";

export function Section2({ deviceType, setDeviceType }: any) {
    return (
        <div className="banner-container">
            <section className="text-section">
                <BannerTable
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    section="Section2"
                    path={[
                        "template",
                        "SiteWeb",
                        "LaindingPage",
                        "Section2",
                        "Images",
                        deviceType,
                    ]}
                    sizeMobile="384*440 (png,jpg,jpeg ou webp)"
                    sizeDesktop="384*440 (png,jpg,jpeg ou webp)"
                />

                <DeleteModal section="Section2" />
            </section>
        </div>
    );
}
